import { render, staticRenderFns } from "./ChooseOrg.vue?vue&type=template&id=22925a51&scoped=true"
import script from "./ChooseOrg.vue?vue&type=script&lang=js"
export * from "./ChooseOrg.vue?vue&type=script&lang=js"
import style0 from "./ChooseOrg.vue?vue&type=style&index=0&id=22925a51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22925a51",
  null
  
)

export default component.exports